/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */

@cc._decorator.ccclass
export default class LayoutWithNotify extends cc.Layout
{
    @cc._decorator.property({ type: [cc.Component.EventHandler], visible: true })
    private _onLayout: cc.Component.EventHandler[] = [];

    protected _doLayout(): void
    {

        const fnDoLayout: string = '_doLayout';
        if (super[fnDoLayout]) { super[fnDoLayout](); }

        this._onLayout.forEach(handler => handler.emit(null));
    }
}
